<ng-container *ngIf="auth.isAuthenticated() && profile">
  <div class="row">
    <div class="col">
      <div class="greeting">
        <h4 class="header">
          Welcome to APSIS One Back Office {{ profile.name }}!
        </h4>
      </div>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-6"></div>
    <div class="col-6">
      <app-recent-routes></app-recent-routes>
    </div>
  </div>
</ng-container>

<div *ngIf="!auth.isAuthenticated()">
  <div class="card">
    <div class="card-body">
      Please <a href="#" (click)="auth.login()">log in</a> to continue.
    </div>
  </div>
</div>
